module.exports = __webpack_public_path__ + "static/media/beachvolley.9ed5e771.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/beachvolley.svg
// module id = 363
// module chunks = 7